import React, {useEffect} from 'react'
import {useForm} from "react-hook-form";
import Card from "../../components/forms/Card";
import FormGroup from "../../components/forms/FormGroup";
import Input from "../../components/forms/FormEl";
import Button from "../../components/forms/Button";
import CategoriaFormSelect from "../../components/selects/CategoriaFormSelect";
const ProductoForm = ({value, onSubmit}) => {

  const {register, handleSubmit, formState: {errors}, reset} = useForm(
    {defaultValues: value}
  );

  useEffect(() => {
    if (value) {
      reset(value)
    }
  }, [value])

  return (
    <form>

      <Card padding>

        <FormGroup>
          <label>Categoria</label>
          <CategoriaFormSelect {...register("categoriaProductoId", {required: "Campo obligatorio"})}/>
          {errors.categoriaProductoId && <p style={{color: 'red'}}>{errors.categoriaProductoId?.message}</p>}
        </FormGroup>
      </Card>

      <Card padding>

        <FormGroup>
          <label>Codigo</label>
          <Input type='text' {...register("codigo", {required: "Campo obligatorio"})}/>
          {errors.codigo && <p style={{color: 'red'}}>{errors.codigo?.message}</p>}
        </FormGroup>

        <FormGroup>
          <label>Nombre</label>
          <Input type='text' {...register("nombre", {required: "Campo obligatorio"})}/>
          {errors.nombre && <p style={{color: 'red'}}>{errors.nombre?.message}</p>}

        </FormGroup>

        <FormGroup>
          <label>Presentacion</label>
          <Input type='text' {...register("presentacion", {required: "Campo obligatorio"})}/>
          {errors.presentacion && <p style={{color: 'red'}}>{errors.presentacion?.message}</p>}

        </FormGroup>

        <FormGroup>
          <label>Beneficios</label>
          <Input type='text' {...register("beneficios", {required: "Campo obligatorio"})}/>
          {errors.beneficios && <p style={{color: 'red'}}>{errors.beneficios?.message}</p>}

        </FormGroup>

        <FormGroup>
          <label>Modo de uso</label>
          <Input type='text' {...register("modoUso", {required: "Campo obligatorio"})}/>
          {errors.modoUso && <p style={{color: 'red'}}>{errors.modoUso?.message}</p>}

        </FormGroup>

        <FormGroup>
          <label>Advertencias</label>
          <Input type='text' {...register("advertencias", {required: "Campo obligatorio"})}/>
          {errors.advertencias && <p style={{color: 'red'}}>{errors.advertencias?.message}</p>}

        </FormGroup>

        <FormGroup>
          <label>Precio lista</label>
          <Input type='number' {...register("precioLista", {required: "Campo obligatorio"})}/>
          {errors.precioLista && <p style={{color: 'red'}}>{errors.precioLista?.message}</p>}

        </FormGroup>

        <FormGroup>
          <label>Porcentaje de descuento</label>
          <Input type='number' {...register("porcDesc", {
            required: "Campo obligatorio",
            validate: value => (parseFloat(value)<= 1 && parseFloat(value) > 0) || "El valor debe ser entre 0 y 1"
          })}/>
          {errors.porcDesc && <p style={{color: 'red'}}>{errors.porcDesc?.message}</p>}
        </FormGroup>

        <FormGroup>
          <label>Precio</label>
          <Input type='number' {...register("precio", {required: "Campo obligatorio"})}/>
          {errors.precio && <p style={{color: 'red'}}>{errors.precio?.message}</p>}
        </FormGroup>

        <FormGroup>
          <label>Extension</label>
          <Input type='text' {...register("extension", {required: "Campo obligatorio"})}/>
          {errors.extension && <p style={{color: 'red'}}>{errors.extension?.message}</p>}
        </FormGroup>

        <FormGroup>
          <label>Stock</label>
          <Input type='number' {...register("stock", {required: "Campo obligatorio"})}/>
          {errors.stock && <p style={{color: 'red'}}>{errors.stock?.message}</p>}
        </FormGroup>
      </Card>

      <Button variant={'primary'} onClick={handleSubmit(onSubmit)}>Guardar</Button>
    </form>
  )
}

export default ProductoForm;
